// extracted by mini-css-extract-plugin
module.exports = {"addPackageButton":"ExtraPackagesSection_addPackageButton__u1CAq"};